/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { UpgradeService } from '../upgrade.service';
import { UpgradeStrService } from '../upgrade-str.service';
import { UpgradeComponent } from './upgrade.component';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CoreModule,
    ],
    declarations: [
        UpgradeComponent,
    ],
    providers: [
        UpgradeComponent,
        UpgradeStrService,
        UpgradeService,
    ],
    exports: [UpgradeComponent],
})

export class UpgradeModule { }
